import React, { useState, useEffect, useRef, useContext } from "react";
import { PermissionService } from "../../../services/permission-service";
import { DataGrid } from "@material-ui/data-grid";
import { Modal } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import { ToastContainer } from "react-toastify";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import AuthContext from "../../../context/auth-context";

export const Accesslevel = (props) => {
  const ctx = useContext(AuthContext);

  const [accessID, setAccessID] = useState("");

  props.accessid(accessID);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [chView, setView] = useState(false);

  const handleChangeView = (event) => {
    setView(event.target.checked);
  };

  const [permission, setPermission] = useState([]);

  const formRef = useRef();

  const [state, setState] = useState(false);

  const [submitloading, setSubmitLoading] = useState(true);

  const [accesslevelID, setaccesslevelID] = useState();

  useEffect(() => {
    accesslevelSearch();
  }, [rowsPerPage, page]);

  const accesslevelSearch = async () => {
    try {
      const result = await PermissionService.accesslevelDetails(
        rowsPerPage,
        page
      );

      setPermission(result);
    } catch (err) {
      //toast
      console.error(err);
    }
  };

  const handleShow4 = (e) => {
    setState({ show4: true });
    setaccesslevelID(e);
  };

  const handleShow3 = (e) => {
    setState({ show3: true });
  };

  const handleClose = (e) => {
    setState({ show3: false });
  };

  const onSubmitForm = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {
    //todo extra validations
    setSubmitLoading(false);

    try {
      await PermissionService.accesslevelCreate(values.access_level);
      formRef.current.resetForm();

      setSubmitLoading(true);
      notify("Access level successfully added");
      handleClose();
      accesslevelSearch();
    } catch (err) {
      notifyWarning(err.response.data.message[0]);
      setSubmitLoading(true);
      //show error toast
    }
  };

  const onDelete = async () => {
    //todo extra validations
    setSubmitLoading(false);
    try {
      await PermissionService.accesslevelDelete(accesslevelID);

      setSubmitLoading(true);
      notify("Access level successfully deleted");
      handleClose();
      accesslevelSearch();
    } catch (err) {
      notifyWarning(err.response.data.message);
      setSubmitLoading(true);
      //show error toast
    }
  };

  const columns = [
    {
      field: "access_level",
      headerName: "Access Level",
      flex: 4,
      sortable: false,
      disableClickEventBubbling: true,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return (
          <div
            onClick={() => {
              setAccessID(params.row.id);
            }}
            style={{ width: "100%", cursor: "pointer" }}
          >
            {params.row.access_level}
          </div>
        );
      },
    },

    {
      field: "delete",
      headerName: "Delete",
      sortable: false,
      flex: 1,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return (
          <div>
            <i
              className="far fa-trash-alt ms-text-danger"
              onClick={() => {
                handleShow4(params.row.id);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        );
      },
    },
  ];

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="row">
            <div className="col-xl-12">
              <div className="ms-panel">
                <div className="ms-panel-header">
                  <div className="row">
                    <div className="col-md-8">
                      <h6>Access Level</h6>
                    </div>
                    <div>
                      <Modal
                        show={state.show4}
                        onHide={handleClose}
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                      >
                        <Modal.Header>
                          <h3 className="modal-title has-icon ms-icon-round ">
                            Confirm Deletion
                          </h3>
                          <button
                            type="button"
                            className="close"
                            onClick={handleClose}
                          >
                            <span aria-hidden="true">×</span>
                          </button>
                        </Modal.Header>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "2vh",
                          }}
                        >
                          <h6 style={{ color: "red" }}>
                            Are you sure you want to remove this item ?
                          </h6>
                        </div>
                        <Modal.Footer>
                          <div className="col-md-2" hidden={submitloading}>
                            <div className="spinner spinner-7">
                              <div className="bounce1" />
                              <div className="bounce2" />
                              <div className="bounce3" />
                            </div>
                          </div>
                          <button
                            type="button"
                            className="btn btn-primary shadow-none"
                            style={{ backgroundColor: "red" }}
                            onClick={onDelete}
                          >
                            Delete
                          </button>

                          <button
                            type="button"
                            className="btn btn-light"
                            onClick={handleClose}
                          >
                            Cancel
                          </button>
                        </Modal.Footer>
                      </Modal>
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <div className="col-md-2 col-sm-4">
                        <button
                          type="button"
                          className="ms-btn-icon btn-primary"
                          name="button"
                          onClick={handleShow3}
                        >
                          <i className="material-icons">person_add</i>{" "}
                        </button>
                      </div>
                      <Modal
                        show={state.show3}
                        onHide={handleClose}
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                      >
                        <Modal.Header>
                          <h3 className="modal-title has-icon ms-icon-round ">
                            <i className="flaticon-share bg-primary text-white" />{" "}
                            Add New Access Level
                          </h3>
                          <button
                            type="button"
                            className="close"
                            onClick={handleClose}
                          >
                            <span aria-hidden="true">×</span>
                          </button>
                        </Modal.Header>
                        <Formik
                          initialValues={{
                            access_level: "",
                          }}
                          validationSchema={Yup.object().shape({
                            access_level: Yup.string().required("Required"),
                          })}
                          onSubmit={onSubmitForm}
                          innerRef={formRef}
                        >
                          {({
                            errors,
                            handleBlur,
                            handleChange,
                            touched,
                            values,
                            submitForm,
                            isValid,
                          }) => (
                            <div>
                              <Modal.Body>
                                <div className="mb-3">
                                  <label htmlFor="validationCustom08">
                                    Access Level
                                  </label>
                                  <div className="input-group">
                                    <input
                                      name="access_level"
                                      type="text"
                                      className="form-control"
                                      id="accesslevel_id"
                                      placeholder="Access Level"
                                      required
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.access_level}
                                    />
                                  </div>
                                  <div
                                    style={{ color: "red", fontSize: "12px" }}
                                  >
                                    {touched.access_level &&
                                      errors.access_level}
                                  </div>
                                </div>

                                <div
                                  className="col-md-2"
                                  hidden={submitloading}
                                >
                                  <div className="spinner spinner-7">
                                    <div className="bounce1" />
                                    <div className="bounce2" />
                                    <div className="bounce3" />
                                  </div>
                                </div>
                              </Modal.Body>

                              <Modal.Footer>
                                <button
                                  type="button"
                                  className="btn btn-light"
                                  onClick={handleClose}
                                >
                                  Cancel
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-primary shadow-none"
                                  onClick={submitForm}
                                >
                                  Add
                                </button>
                                <div>
                                  <ToastContainer />
                                </div>
                              </Modal.Footer>
                            </div>
                          )}
                        </Formik>
                      </Modal>
                    </div>
                  </div>
                </div>

                <DataGrid
                  rows={permission}
                  columns={columns}
                  pageSize={100}
                  page={page}
                  hideFooter
                  autoHeight
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Accesslevel;
